import { render, staticRenderFns } from "./reset-pwd.vue?vue&type=template&id=27cd3e16&scoped=true"
import script from "./reset-pwd.vue?vue&type=script&lang=ts"
export * from "./reset-pwd.vue?vue&type=script&lang=ts"
import style0 from "./reset-pwd.vue?vue&type=style&index=0&id=27cd3e16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cd3e16",
  null
  
)

export default component.exports